import RoleService from "@/services/RoleService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const role = {
    namespace:true,
    state: {roles:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListRole({commit},pageNumber){
            return await RoleService.getlist(pageNumber).then(
                response=>{    
                    commit('setRoles',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListRole({commit},search){          
            return await RoleService.getSearch(search).then (
                response =>{                    
                    commit('setRoles',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setRoles(state,data){
        state.roles = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.roles.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};